<template>
  <section class="base-section notFound py-16">
    <div class="container row justify-content-center center-align">
      <div class="col s10">
        <h1 class="text-[22px] md:text-[24px] regular uppercase grey-text">
          {{ $t('loadingError') }}
        </h1>
        <br>
        <p class="h3 grey-text text-darken-4">
          {{ $t('loadingErrorDescr') }}
        </p>
        <p class="h5 regular em semibold">
          {{ $t('loadingErrorDescr2') }}
        </p>

        <div
          v-if="props.data"
          ref="consoleRef"
          class="relative bg-gray-900 text-gray-100 p-4 rounded-lg overflow-x-auto text-sm font-mono max-h-[400px] overflow-auto flex flex-col mb-8"
        >
          {{ JSON.stringify(props.data) }}

          <button 
            class="absolute top-2 right-2 text-gray-400 hover:text-gray-200 transition p-1 bg-gray-800 rounded-md text-xs"
            :disabled="!isSupported"
            @click="() => {
              if (consoleRef.innerHTML) {
                let textContent = consoleRef.innerHTML
                  ?.replace(/<\/(div|p|br)>/g, '\n')
                  ?.replace(/<[^>]+>/g, '')
                  
                copy(textContent)

                toast.add({
                  severity: 'contrast',
                  detail: i18n?.t('copied'),
                  life: 5000
                })
              }
            }"
          >
            📋 {{ $t('copy') }}
          </button>
        </div>

        <div class="btn-holder center-align">
          <a
            role="button"
            class="btn waves-effect waves-light"
            :href="useRoute().fullPath"
          >
            {{ $t('reloadPage') }}
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
const { $i18n: i18n } = useNuxtApp()
const { getBreadcrumbs } = useBreadcrumbs()
const { layout } = useHelpers()
const toast = useToast()
const { copy, isSupported } = useClipboard()

const consoleRef = ref(null)

layout.value = 'pageError'

const props = defineProps({
  data: {
    type: [String, Object],
    default: null
  }
})

useHead({
  title: i18n?.t('loadingError'),
  meta: [
    { name: 'description', content: i18n?.t('loadingError') }
  ]
})

getBreadcrumbs({}, 'pageError')
</script>

<style  lang="scss" scoped>
.loadingError {
  display: flex;
  align-items: center;
  height: 60vh;
  text-align: center;
  h1.larger {
    margin: 2rem auto;
    font-size: 7rem;
    line-height: 1;
    text-transform: lowercase;
  }
  h1,
  h2,
  h3 {
    margin: auto;
    color: #ccc;
    font-weight: 400;
  }
}
</style>
